// Subpath import, not the barrel: this module is browser-reachable via
// @arti/schemas/dashboard, and the barrel pulls in Node-only modules
// (providerPaths → node:url) that break the vite build.
import { SELECTABLE_ACTOR_MODELS } from "@arti/ai-models-config/selectableActorModels";
import z from "zod";

import { isValidConsolidationSchedule } from "./scheduleGrammar";

export const ACTOR_AVATAR_SEED_MAX_LENGTH = 64;
export const ACTOR_CONSOLIDATION_SCHEDULE_MAX_LENGTH = 200;
export const ACTOR_TICK_INTERVAL_MS_MIN = 1000;

const selectableActorModelRefs = new Set(
  SELECTABLE_ACTOR_MODELS.map((model) => model.ref),
);

export const actorAvatarSeedSchema = z
  .string()
  .trim()
  .min(1)
  .max(ACTOR_AVATAR_SEED_MAX_LENGTH);

export const actorConsolidationScheduleSchema = z
  .string()
  .trim()
  .max(ACTOR_CONSOLIDATION_SCHEDULE_MAX_LENGTH)
  .refine(isValidConsolidationSchedule, {
    message:
      "must be interval:<seconds>, daily:HH:MM[@timezone], or cron:<expression>",
  });

export const resolvableActorModelRefSchema = z
  .string()
  .trim()
  .refine((modelRef) => selectableActorModelRefs.has(modelRef), {
    message: "must reference a selectable actor model",
  });

export const actorTickIntervalMsSchema = z
  .number()
  .int()
  .min(ACTOR_TICK_INTERVAL_MS_MIN);
